var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isinWarning
        ? _c(
            "BaseAlert",
            {
              staticClass: "my-2",
              attrs: { icon: "warning", "icon-color": "warning" }
            },
            [
              _c("span", { staticClass: "text-normal" }, [
                _vm._v(" " + _vm._s(_vm.isinWarning) + " ")
              ])
            ]
          )
        : _vm._e(),
      _c("MovementsEventsTable", {
        attrs: {
          mode: "events",
          "hide-title": "",
          asset: _vm.asset,
          proventos: _vm.proventos,
          splits: _vm.splits,
          loading: _vm.loading,
          "event-items": _vm.eventItems
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }